import React, { useContext, useState } from "react"
import { useTranslation } from "react-i18next"
import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close'
import { ToastContext } from "../../../contexts/toast-context.jsx"
import { useQuery } from "@tanstack/react-query"
import { getProject } from "../../../api/project-api.js"
import { BillingInfo } from "../../profile/billing-info.jsx"
import { UserContext } from "../../../contexts/user-context.jsx"
import { CheckoutProject } from "./checkout-project.jsx"
import { BillingInfoOverview } from "./billing-info-overview.jsx"

export const BuyProject = ({ open, onClose, projectId }) => {
  const { t } = useTranslation(["buy", "common"])
  const { showSuccess } = useContext(ToastContext)
  const { user } = useContext(UserContext)
  const { data: project, isPending: projectIsPending } = useQuery({
    queryKey: ['project', projectId],
    queryFn: async () => {
      return (await getProject(projectId)).data
    },
    enabled: projectId !== null
  })
  const loading = projectIsPending

  function handleSuccess() {
    onClose(true)
    showSuccess(t("successfulPurchase"))
  }

  const [billingInfo, setBillingInfo] = useState(null)
  const [updateBillingInfo, setUpdateBillingInfo] = useState(false)

  function handleBillingInfoSaved(x) {
    setBillingInfo(x)
    setUpdateBillingInfo(false)
  }

  function handleBillingInfoLoaded(x) {
    setBillingInfo(x)
  }

  const notCreator = project && project.createdById !== user.id

  return (
    <Dialog open={open} onClose={() => onClose(false)} maxWidth="xs" fullWidth>
      <DialogTitle>{t("buyProject")}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => onClose(false)}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ overflow: "visible" }}>
        {loading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CircularProgress size={30} sx={{ mt: 3 }} />
          </Box>
        )}

        {!loading && <>
          <Box sx={{ pb: 2, color: "#ff5050" }}>A fizetési rendszer tesztelés alatt van, ezért nem történik valódi fizetés és számla kiállítás!</Box>
          {notCreator && <Box sx={{ pb: 2 }}>{t("notCreator")}</Box>}
          {!notCreator && <>
            {(!billingInfo || updateBillingInfo) && <Box>
              <Box sx={{ pb: 2 }}>{t("enterBillingInfoFirst")}</Box>
              <BillingInfo userId={user.id} allowSaveWithoutChange={true} onLoad={handleBillingInfoLoaded} onSaved={handleBillingInfoSaved} />
            </Box>}
            {(billingInfo && !updateBillingInfo) && project &&
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <BillingInfoOverview billingInfo={billingInfo} onChange={() => setUpdateBillingInfo(true)} />
                <CheckoutProject project={project} onSuccess={handleSuccess} />
              </Box>
            }
          </>}
        </>}
      </DialogContent>
    </Dialog>
  )
}
